import styled from 'styled-components'
import { media } from 'styles/media'
import typeStyle from 'styles/typeStyle'

export const Outer = styled.div`
  position: relative;
  background-color: ${({ theme }) => theme?.['-ds-core-50']?.value};
  border-radius: 8px;
  overflow: hidden;

  ${media.md`
    display: flex;
    flex-direction: row;
  `}
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 100%;
  padding: 32px 16px;

  ${media.md`
    width: 50%;
    padding: 80px 0 80px 48px;
    align-items: flex-start;
    text-align: left;
  `}

  ${media.xl`
    width: 65%;
    padding: 120px 0 120px 48px;
  `}
  

  h2 {
    color: ${({ theme }) => theme?.['-ds-core-400']?.value};
    line-height: 1.3;
    margin-bottom: 16px;
    margin-top: 8px;

    ${media.md`
      margin-bottom: 24px;
      margin-top: 16px;
    `}
  }

  p {
    margin-bottom: 28px;
  }

  a {
    margin: 0;
  }
`

export const BoldHeading = styled.strong`
  ${typeStyle('-ds-font-title-large')}
  display: block;

  ${media.md`
        display: inline;
      `}
`

export const LightHeading = styled.span`
  ${typeStyle('-ds-font-title-large-light')}
`

export const Moment = styled.div`
  margin-right: 24px;
`

export const Image = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 1500px;

  ${media.md`
    position: absolute;
    flex-direction: column;
    justify-content: flex-end;
    width: 100%;
    bottom: -40px;
    right: 20px;
    width: 50%;
  `}

  > div {
    display: flex;
    flex-direction: row;

    &:nth-child(1) {
      margin-left: -1%;
      ${media.md`
        padding-left: 65%;
      `}
    }

    &:nth-child(2) {
      ${media.md`
        padding-left: 45%;
      `}
    }

    &:nth-child(3) {
      margin-left: -10%;

      ${media.md`
        padding-left: 35%;
      `}
    }

    ${Moment} {
      margin-bottom: 30px;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
`
